import ozon_icon from './img/ozon_icon.svg';
import customHeaders, { getSpace } from '../../common/headers';
import info_icon from './img/info-red.svg';
import banner_no_data from './img/banner-no-data.svg';
import { Rating } from '@mui/material';
import { ChatReview } from '../../components/ChatReview/ChatReview';
import { ModalReview } from '../../components/Modal/ModalReview/ModalReview';
import { TabsGreyBtn } from '../../components/TabsGreyBtn/TabsGreyBtn';
import { FilterContainer } from '../../components/FilterContainer/FilterContainer';
import { ModalUnansweredFeedback } from '../../components/Modal/ModalUnansweredFeedback/ModalUnansweredFeedback';
import { ReactComponent as StarIcon } from './img/rating_star.svg';
import { useState, useEffect, useRef } from 'react';
import { ModalAlert } from '../../components/Modal/ModalAlert/ModalAlert';
import {
  useLocation,
  useParams
} from 'react-router-dom';
import useModal from '../../store/modal';
import { useShallow } from 'zustand/react/shallow';
import {
  TableBox,
  RangeBox,
  Tabs,
  DropDownSelector,
  ButtonBasic,
  ViewSwitch,
  CheckboxToggleBlue,
  NoDataContent,
  Tooltip,
  ModalCrm
} from '@lk-gtcom/ecomlab-components';
import { KonstantinMasterHttps } from '../../fetchUrls';
import { fetchFilterV3 } from '../../common/filtersFunc';
import useGeneralStore from '../../store/general';
import { useDataTable } from '../../common/hooks';
import './WorkWithReviews.scss';
import { TitlePage } from '../../components/TitlePage/TitlePage';
import { getValueMultiFilter } from '../../common/filtersFunc';
import { options_prop_mp } from '../../common/globalVariables';
import { MoonLoader } from 'react-spinners';
import { usePushNotifications } from '../../common/pushNotification';
import { periodWeek } from '../../common/constant';
import { msToLocalDate } from '../../common/constant';
import { useURLSearchParams } from '../../common/useURLSearchParams';
import { useResponseHandler } from '../../common/auth';
import { useSavedFilters } from '../../common/useSavedFilters';

// Отмена запросов для фильтров
import { RequestController } from '../../common/filtersFunc';

const btn_tab = [
  { label: 'Отзывы', value: 'feedbacks' },
  { label: 'Вопросы', value: 'questions' },
];

const optionRating = (rating) => {
  return (
    <div className="rating-option">
      <span className="text_span">{rating}</span>
      <Rating
        precision={1}
        defaultValue={rating}
        max={1}
        readOnly
        emptyIcon={<StarIcon style={{ opacity: '.1' }} />}
        icon={<StarIcon style={{ fill: '#faaf00' }} />}
        size="small"
      />
    </div>
  );
};

const ratingData = [
  { label: optionRating(1), value: 1 },
  { label: optionRating(2), value: 2 },
  { label: optionRating(3), value: 3 },
  { label: optionRating(4), value: 4 },
  { label: optionRating(5), value: 5 },
];

const WorkWithReviews = ({
  openConnectionModalById,
  setQueryFeedbacks
}) => {

  const selectedSpace = useGeneralStore((state) => state.selectedSpace);
  const headers = { ...customHeaders, ...getSpace(selectedSpace) };
  // Сохранённые фильтры: подставляются в URL при заходе, запись по кнопке
  const { isReady, saveFilters, clearSavedFilters, isSaved, hasSavedFilters } = useSavedFilters(selectedSpace?.value, 'work-with-reviews');
  const { handleTableResponse, handleRequestError } = useResponseHandler();
  // Обработка ошибок
  const { addErrorPush, addSuccessPush, addWarningPush } = usePushNotifications();
  const path = useParams();
  const location = useLocation();
  const {
    setIsModalActive,
    setSelectedServiceItemId,
  } = useModal(
    useShallow((state) => ({
      isModalActive: state.isModalActive,
      setIsModalActive: state.setIsModalActive,
      selectedServiceItemId: state.selectedServiceItemId,
      setSelectedServiceItemId: state.setSelectedServiceItemId,
    }))
  );



  // Рефы
  const fileInputRef = useRef(null);

  const [isNotOneAccount, setIsNotOneAccount] = useState('done');

  const [isTableRequest, setIsTableRequest] = useState(false);

  const [view, setView] = useState('Table');
  const [showTabView, setShowTabView] = useState(true);
  const [pageValue, setPageValue] = useState('feedbacks');
  const [currentSort, setCurrentSort] = useState([]);
  const [counterData, setCounterData] = useState({});

  const current_page = pageValue == 'feedbacks' ? 'feedbacks' : 'questions'

  const paginatorRef = useRef();
  const [setTable, tableProps, setTableFuncs] = useDataTable(
    paginatorRef.current?.setTotal,
    paginatorRef
  );
  const { setLoading, setFetchedData, setHeaders, setSort } = setTableFuncs;
  const { loading, sort, filters } = tableProps;
  const [loadingUpload, setLoadingUpload] = useState(false)
  const [isModalAlert, setIsModalAlert] = useState(false);
  const [textAlert, setTextAlert] = useState('');

  const btns = [
    { label: 'Все', count: counterData?.['all'], value: 'Все' },
    { label: 'Отвеченные', count: counterData?.['answered'], value: 'Ответ отправлен' },
    { label: 'Неотвеченные', count: counterData?.['unanswered'], value: 'Ответ не отправлен' },
    { label: 'Модерация', count: counterData?.['moderation'], value: 'Модерация' },
    { label: 'Ответ ожидает отправления', count: counterData?.['confirmed_moderation'], value: 'Ответ ожидает отправления' },
  ];

  const [isModal, setIsModal] = useState(false);
  const [questData, setQuestData] = useState({});
  const activeTab = useParams()['*'];

  // Даты
  const [date, setDate] = useState(periodWeek());
  const [dateFrom, dateTo] = date;
  const [allPeriod, setAllPeriod] = useState(false)

  // Табы
  const [selectedStatus, setSelectedStatus] = useState('Все');

  // Каунтер 
  const [totalCounter, setTotalCounter] = useState(0);
  const [isLoadCounter, setIsLoadCounter] = useState(true);

  // Фильтры
  const filterConfig = [
    { key: 'mp', type: 'multi' },
    { key: 'api', type: 'multi' },
    { key: 'category', type: 'multi' },
    { key: 'brand', type: 'multi' },
    { key: 'rating', type: 'multi' },
    { key: 'date_from', type: 'date' },
    { key: 'date_to', type: 'date' }
  ];
  const { urlParams, updateURL, isInitialized, hasInitialParams } = useURLSearchParams(filterConfig);
  const [isFilterRequest, setIsFilterRequest] = useState(false);

  const [apiData, setApiData] = useState([]);
  const [categoryData, setCategoryData] = useState([]);
  const [brandData, setBrandData] = useState([]);

  const [selectedMarketplace, setSelectedMarketplace] = useState([{ label: 'Все', value: 'all' }]);
  const [selectedApi, setSelectedApi] = useState([{ label: 'Все', value: 'all' }]);
  const [selectedCategory, setSelectedCategory] = useState([{ label: 'Все', value: 'all' }]);
  const [selectedBrand, setSelectedBrand] = useState([{ label: 'Все', value: 'all' }]);
  const [selectedRating, setSelectedRating] = useState([{ label: 'Все', value: 'all' }]);

  const [apiPage, setApiPage] = useState(1);
  const [categoryPage, setCategoryPage] = useState(1);
  const [brandPage, setBrandPage] = useState(1);

  const [apiQuery, setApiQuery] = useState('');
  const [categoryQuery, setCategoryQuery] = useState('');
  const [brandQuery, setBrandQuery] = useState('');

  const [totalApi, setTotalApi] = useState(0);
  const [totalCategory, setTotalCategory] = useState(0);
  const [totalBrand, setTotalBrand] = useState(0);

  const [isSearchLastPage, setIsSearchLastPage] = useState(false);
  const [chatPage, setChatPage] = useState(1);
  const [resetHeight, setResetHeight] = useState(false);

  const [isModalUnansweredFeedback, setIsModalUnansweredFeedback] = useState(false);
  const [isAllUnanswered, setIsAllUnanswered] = useState(false);
  const [currentHref, setCurrentHref] = useState('');
  const [isCheckWithText, setIsCheckWithText] = useState(false);

  // Инициализация фильтров из URL параметров при первом рендере
  const [isInitialLoadFromURL, setIsInitialLoadFromURL] = useState(false);

  useEffect(() => {
    if (!isReady) return;
    if (!isInitialLoadFromURL) {
      setIsInitialLoadFromURL(true);

      // Обновляем все состояния фильтров
      setTimeout(() => {
        if (urlParams.mp) setSelectedMarketplace(urlParams.mp)
        if (urlParams.api) setSelectedApi(urlParams.api)
        if (urlParams.category) setSelectedCategory(urlParams.category)
        if (urlParams.brand) setSelectedBrand(urlParams.brand)
        if (urlParams.rating) setSelectedRating(urlParams.rating?.map(el => ({ label: el?.value == 'all' ? 'all' : optionRating(el?.value), value: el?.value })))
        if (urlParams.date_from) {
          setDate([
            new Date(parseInt(urlParams.date_from)),
            new Date(parseInt(urlParams.date_to)),
          ]);
        }

        // Запускаем запрос таблицы и фильтров только при первой инициализации из URL
        setIsFilterRequest(prev => !prev);
        if (Object.keys(urlParams).length > 0) {
          setIsTableRequest(prev => !prev);
        }
      }, 10);
    }
  }, [urlParams, isReady]);

  useEffect(() => {
    if (!isReady) return;
    updateURL({
      mp: urlParams?.mp || selectedMarketplace,
      api: urlParams?.api || selectedApi,
      category: urlParams?.category || selectedCategory,
      brand: urlParams?.brand || selectedBrand,
      rating: urlParams?.rating || selectedRating,
      date_from: urlParams?.date_from || dateFrom,
      date_to: urlParams?.date_to || dateTo,
    })
  }, [isReady]);

  // Создаем реф для хранения контроллера запросов
  const requestControllerRef = useRef(new RequestController());

  useEffect(() => {
    setQueryFeedbacks(window?.location?.search);
  }, [window?.location?.search]);

  const filtersApi = () => {
    const controller = requestControllerRef.current.createController('api');

    fetchFilterV3({
      selectedSpace: selectedSpace?.value,
      selectedMP: selectedMarketplace,
      page: apiPage,
      set: setApiData,
      searchParam: apiQuery,
      controller,
      setTotal: setTotalApi,
      dateFrom,
      dateTo,
      filter: 'fq_api_ids'
    })?.finally(() => {
      requestControllerRef.current.removeController('api');
    })
  };

  const filtersCategory = () => {
    const controller = requestControllerRef.current.createController('category');

    fetchFilterV3({
      selectedSpace: selectedSpace?.value,
      selectedMP: selectedMarketplace,
      selectedApi,
      page: categoryPage,
      set: setCategoryData,
      searchParam: categoryQuery,
      controller,
      setTotal: setTotalCategory,
      dateFrom,
      dateTo,
      filter: pageValue === 'feedbacks' ? 'feedbacks_categories' : 'questions_categories_new'
    })?.finally(() => {
      requestControllerRef.current.removeController('category');
    })
  };

  const filtersBrand = () => {
    const controller = requestControllerRef.current.createController('brand');

    fetchFilterV3({
      selectedSpace: selectedSpace?.value,
      selectedMP: selectedMarketplace,
      page: brandPage,
      selectedApi,
      selectedCategory,
      searchParam: brandQuery,
      set: setBrandData,
      controller,
      setTotal: setTotalBrand,
      dateFrom,
      dateTo,
      filter: pageValue === 'feedbacks' ? 'feedbacks_brands' : 'questions_brands_new'
    })?.finally(() => {
      requestControllerRef.current.removeController('brand');
    })
  };

  useEffect(() => {
    if (!isInitialLoadFromURL) return;
    filtersApi();
  }, [isFilterRequest, apiPage, apiQuery, pageValue]);

  useEffect(() => {
    if (!isInitialLoadFromURL) return;
    filtersCategory();
  }, [isFilterRequest, dateFrom, dateTo, categoryPage, categoryQuery, pageValue]);

  useEffect(() => {
    if (!isInitialLoadFromURL) return;
    filtersBrand();
  }, [isFilterRequest, dateFrom, dateTo, brandPage, brandQuery, pageValue]);

  useEffect(() => {
    return () => {
      // Отменяем все активные запросы фильтров
      requestControllerRef.current.abortAll();
    };
  }, []);

  useEffect(() => {
    setPageValue(activeTab);
    setCounterData({});
  }, [activeTab]);

  useEffect(() => {
    if (path['*'] == 'archive') {
      setView('table');
      setShowTabView(false);
    } else {
      setShowTabView(true);
    }
  }, [path]);

  const fetchTableData = (params, abortController) => {
    if (view === 'chat') return;
    if (!selectedStatus) return

    setLoading(true);

    let sort;
    let filtersParam = [];

    if (params) {
      [sort, filtersParam] = params;
    }

    let url = `${KonstantinMasterHttps}/wb/${pageValue}/table?with_text=${isCheckWithText}${sort?.length > 0
      ? '&order_param=' + sort[0] + '&order_param_direction=' + sort[1]
      : ''}`

    const body = JSON.stringify({
      page: paginatorRef.current?.page,
      limit: paginatorRef.current?.limit,
      filters: filtersParam,
      category_id_list: getValueMultiFilter(selectedCategory),
      brand_id_list: getValueMultiFilter(selectedBrand),
      api_id_list: getValueMultiFilter(selectedApi),
      mp_id_list: getValueMultiFilter(selectedMarketplace),
      product_valuation_list: getValueMultiFilter(selectedRating),
      status: selectedStatus,
      date_from: allPeriod ? null : msToLocalDate(dateFrom),
      date_to: allPeriod ? null : msToLocalDate(dateTo),
    });


    fetch(url, { body, method: 'POST', headers, signal: abortController?.signal })
      .then(handleTableResponse)
      .then((json) => setTable(json))
      .catch(handleRequestError)
      .finally(() => {
        if (abortController?.signal.aborted) return
        setLoading(false)
      })
  };

  // Каунтер
  const fetchCounter = (params, abortController) => {
    let sort;
    let filtersParam = [];

    if (params) {
      [sort, filtersParam] = params;
    }

    let url = `${KonstantinMasterHttps}/wb/${pageValue}/counter?with_text=${isCheckWithText}`;

    const body = JSON.stringify({
      page: paginatorRef.current?.page,
      limit: paginatorRef.current?.limit,
      filters: filtersParam,
      category_id_list: getValueMultiFilter(selectedCategory),
      brand_id_list: getValueMultiFilter(selectedBrand),
      api_id_list: getValueMultiFilter(selectedApi),
      product_valuation_list: getValueMultiFilter(selectedRating),
      mp_id_list: getValueMultiFilter(selectedMarketplace),
      status: selectedStatus?.label,
      date_from: allPeriod ? null : msToLocalDate(dateFrom),
      date_to: allPeriod ? null : msToLocalDate(dateTo),
    });

    fetch(url, { body, method: 'POST', headers, signal: abortController?.signal })
      .then(handleTableResponse)
      .then((json) => setCounterData(json))
      .catch(handleRequestError)
      .finally(() => {
        if (abortController?.signal.aborted) return
      })
  };

  // Основной тотал каунтер
  const fetchTotalCounter = () => {
    setIsLoadCounter(true)
    let url = `${KonstantinMasterHttps}/feedbacks-and-questions/counters/unanswered`

    fetch(url, { method: 'GET', headers })
      .then(handleTableResponse)
      .then(({ feedbacks, questions }) => setTotalCounter({ feedbacks, questions }))
      .catch(handleRequestError)
      .finally(() => setIsLoadCounter(false))
  };

  // Изменение статуса 
  const fetchChangeStatus = (status) => {
    if (checkItems.length > 0) {
      let url = `https://apps1.ecomru.ru:4455/${current_page}/moderation/confirmed-status/by-list`;

      const body = JSON.stringify({
        [current_page]: checkItems,
        confirmed: status
      });

      fetch(url, { body, method: 'PUT', headers })
        .then(handleTableResponse)
        .then((json) => setIsTableRequest(!isTableRequest))
        .catch(handleRequestError);
    }
  };

  // Изменение подтвержденного статуса для отфильтрованных вопросов в таблице модерации.
  const fetchChangeStatusByFilters = (status) => {
    let url = `https://apps1.ecomru.ru:4455/${current_page}/moderation/confirmed-status/by-filters`;

    const body = JSON.stringify({
      filters: {
        mp_id_list: getValueMultiFilter(selectedMarketplace),
        api_id_list: getValueMultiFilter(selectedApi),
        category_id_list: getValueMultiFilter(selectedCategory),
        brand_id_list: getValueMultiFilter(selectedBrand),
        date_from: allPeriod ? null : msToLocalDate(dateFrom),
        date_to: allPeriod ? null : msToLocalDate(dateTo),
        product_valuation_list: getValueMultiFilter(selectedRating),
        with_text: isCheckWithText
      },
      confirmed: status
    });

    fetch(url, { body, method: 'PUT', headers })
      .then(handleTableResponse)
      .then((json) => setIsTableRequest(!isTableRequest))
      .catch(handleRequestError);
  };

  // Загрузить шаблон
  const onUploadFileToPromotion = (file) => {
    if (!file) return;

    setLoadingUpload(true)
    addWarningPush('Дождитесь окончания загрузки, после завершения процесса  появится уведомление')
    const url = `https://apps0.ecomru.ru:4449/wb/feedbacks/table/feedback-answer`;

    const formData = new FormData();
    formData.append('upload_file', file);

    const updatedHeaders = { ...headers };
    delete updatedHeaders['Content-Type'];

    fetch(url, { method: 'POST', updatedHeaders, headers: updatedHeaders, body: formData })
      .then(async (res) => {
        const data = await res.json(); // парсим ответ один раз
        if (!res.ok) {
          const errorMessage = data.detail;
          addErrorPush(`Ошибка загрузки: ${errorMessage}`);
          throw new Error(`Upload failed: ${res.statusText}`);
        }
        return data;
      })
      .then((data) => {
        addSuccessPush(data?.Success)
        if (fileInputRef.current) fileInputRef.current.value = ''
        setIsTableRequest(!isTableRequest)
      })
      .catch((err) => {
        console.error(err);
        if (fileInputRef.current) fileInputRef.current.value = ''
      })
      .finally(() => setLoadingUpload(false));
  };

  const handleFileChange = async (e) => {
    onUploadFileToPromotion(e.target.files[0]);
  };

  const onActionHandle = (data) => {
    const {
      feedback_id,
      question_id,
      api_id,
      Оценка,
      Фото,
      Товар,
      Дата,
      Магазин,
      Отзыв,
      category_name,
      mp_id,
    } = data;
    const [productName, productLink] = Товар;
    const date = Дата;
    const brand = Магазин;
    const review = Отзыв;
    const status = data?.['Cтатус ответа'];
    const offer_id = productLink
      ?.split('/')
      ?.filter((el) => {
        const check = el?.replace(/[0-9]+/, '');
        if (!check) return el;
      })
      ?.join('');

    setQuestData({
      id: pageValue === 'feedbacks' ? feedback_id : question_id,
      mp_id,
      api_id,
      rating: Оценка,
      img: Фото,
      productName,
      category_name,
      offer_id,
      date,
      brand,
      review,
      status,
      link: productLink
    });

    setIsModal(true);
  };

  const [checkItems, setCheckItems] = useState([]);

  // Подтверждение / отмена модерации
  const onCheck = (e) => {
    const data = e.map(({ feedback_id, question_id, api_id, mp_id }) => {
      return {
        mp_id: mp_id,
        api_id: api_id,
        id: feedback_id ? feedback_id : question_id
      };
    });
    setCheckItems(data);
  };

  useEffect(() => {
    if (!isReady) return;
    if (view === 'Table') {
      const abortController = new AbortController();
      setResetHeight(true);
      setChatPage(1);
      fetchTableData([], abortController);
      return () => abortController.abort();
    }
  }, [
    date,
    allPeriod,
    pageValue,
    isTableRequest,
    selectedStatus,
    view,
    ...(pageValue === 'feedbacks') ? [isCheckWithText] : []
  ]);

  useEffect(() => {
     if (!isReady) return;
    const abortController = new AbortController();
    setResetHeight(true);
    setChatPage(1);
    fetchCounter([], abortController);
    return () => abortController.abort();
  }, [
    date,
    allPeriod,
    pageValue,
    isTableRequest,
    selectedStatus,
    isCheckWithText
  ]);

  useEffect(() => {
    if (view !== 'chat') {
      setCurrentSort([]);
    }
  }, [view]);

  useEffect(() => {
    fetchTotalCounter();
  }, []);

  useEffect(() => {
    if (selectedRating?.length == ratingData?.length - 1) {
      setSelectedRating([{ label: 'Все', value: 'all' }]);
    }
  }, [selectedRating]);

  useEffect(() => {
    setCurrentHref(window.location.href);
  }, []);

  useEffect(() => {
    setSelectedStatus('Все');
  }, [pageValue]);

  // для модалки
  const [isModalForm, setIsModalForm] = useState(false)
  const formStubData = [
    { id: 'name', placeholder: 'Имя', inputType: 'text', type: 'input', required: true },
    { id: 'ff_60', placeholder: 'Номер телефона', inputType: 'tel', type: 'input' },
    { id: 'ff_59', placeholder: 'Email', inputType: 'email', type: 'input' },
  ]

  const formStubTitle = 'Добавить OZON'
  const formStubSubTitle = 'Если у вас нет Premium на Озон, то мы все равно можем отвечать на отзывы автоматически. Оставьте заявку и мы свяжемся с вами и расскажем про весь процесс подключения.'
  const urlFetch = ` https://portals.ecomru.ru/api/crm/deals/create?step_id=281&token=gAAAAABpcPJSHhvC6-XEaz0AplqvbriR1nEVCEI-5t9wRYciZMOVc9YrAAz72AsHYjEE1P7YXr3Hga9ozPKosL6wZGPoqIRXXw==&author=197&responsible=689&ff_61=${selectedSpace?.value}`



  return (
    <>
      {isModalUnansweredFeedback && (
        <ModalUnansweredFeedback
          setIsModal={(e) => setIsModalUnansweredFeedback(e)}
          setIsAllUnanswered={(e) => setIsAllUnanswered(e)}
          totalCounter={totalCounter}
          date={allPeriod ? [new Date(0), new Date()] : date}
        />
      )}

      {isModalAlert && <ModalAlert
        title={textAlert}
        setIsModal={(e) => setIsModalAlert(e)}
      />}

      {isModal && (
        <ModalReview
          selectedStatus={selectedStatus}
          pageValue={pageValue}
          questData={questData}
          setQuestData={(e) => setQuestData(e)}
          setIsModal={(e) => setIsModal(e)}
          setIsTableRequest={setIsTableRequest}
          fetchCounter={fetchCounter}
        />
      )}

      {isModalForm && <ModalCrm
        setIsModal={setIsModalForm}
        inputArr={formStubData}
        formTitle={formStubTitle}
        subTitle={formStubSubTitle}
        urlFetch={urlFetch}
      />}

      <div className="work-with-reviews">
        <div className="work-with-reviews__content">
          <div className="work-with-reviews__header">
            <div className="work-with-reviews__title-counter-container">
              <TitlePage
                title={'Работа с отзывами и вопросами'}
              />

              <Tooltip
                text={`Количество неотвеченных отзывов ${totalCounter?.feedbacks} и вопросов ${totalCounter?.questions} за весь период`}
                child={
                  <span
                    className="counter"
                    onClick={(e) => {
                      setIsModalUnansweredFeedback(true);
                      setIsAllUnanswered(true);
                    }}
                  >
                    {isLoadCounter ?
                      <MoonLoader
                        size={18}
                        color="#51ca64"
                        speedMultiplier={0.5}
                      />
                      :
                      ((totalCounter?.feedbacks + totalCounter?.questions)
                        ?
                        <>
                          {totalCounter?.feedbacks + totalCounter?.questions}
                          <img src={info_icon} />
                        </>
                        : 0)
                    }
                  </span>
                }
              />
            </div>

            {pageValue === 'feedbacks' && (
              <button
                onClick={(e) => {
                  setIsModalForm(true)
                }}
                className="btn-ozon"
              >
                <span>Добавить</span>
                <img src={ozon_icon} />
              </button>
            )}
          </div>

          <div className="work-with-reviews__filters">
            <FilterContainer
              loading={isSaved}
              saveFilters={saveFilters}
              clearSavedFilters={clearSavedFilters}
              hasSavedFilters={hasSavedFilters}
              onReset={(e) => {
                setSelectedMarketplace([]);
                setSelectedApi([]);
                setSelectedCategory([]);
                setSelectedBrand([]);
                setSelectedRating([]);
                updateURL({
                  mp: null,
                  api: null,
                  category: null,
                  brand: null,
                  rating: null,
                });
                setIsTableRequest(!isTableRequest)
                setIsFilterRequest(!isFilterRequest);
              }}
            >
              <DropDownSelector
                options_prop={options_prop_mp}
                state={selectedMarketplace}
                setState={setSelectedMarketplace}
                placeholder="Маркетплейс"
                total={options_prop_mp?.length}
                multi
                onBlur={() => {
                  updateURL({ mp: selectedMarketplace });
                  filtersApi();
                  filtersCategory();
                  filtersBrand();
                  setIsTableRequest(!isTableRequest);
                }}
              />

              <DropDownSelector
                options_prop={apiData}
                state={selectedApi}
                setState={setSelectedApi}
                placeholder="Магазин"
                total={totalApi}
                fetchCallback={setApiPage}
                setInputChange={setApiQuery}
                multi
                onBlur={() => {
                  updateURL({ api: selectedApi });
                  filtersCategory();
                  filtersBrand();
                  setIsTableRequest(!isTableRequest);
                }}
              />

              <DropDownSelector
                options_prop={categoryData}
                state={selectedCategory}
                setState={setSelectedCategory}
                placeholder="Категория"
                total={totalCategory}
                fetchCallback={setCategoryPage}
                setInputChange={setCategoryQuery}
                multi
                onBlur={() => {
                  updateURL({ category: selectedCategory });
                  filtersBrand();
                  setIsTableRequest(!isTableRequest);
                }}
              />

              <DropDownSelector
                options_prop={brandData}
                state={selectedBrand}
                setState={setSelectedBrand}
                placeholder="Бренд"
                total={totalBrand}
                fetchCallback={setBrandPage}
                setInputChange={setBrandQuery}
                multi
                onBlur={() => {
                  updateURL({ brand: selectedBrand });
                  setIsTableRequest(!isTableRequest);
                }}
              />

              {pageValue === 'feedbacks' ? (
                <DropDownSelector
                  options_prop={ratingData}
                  state={selectedRating}
                  setState={setSelectedRating}
                  placeholder="Рейтинг"
                  total={ratingData?.length}
                  multi
                  onBlur={() => {
                    updateURL({ rating: selectedRating.map((el) => ({ label: el.value, value: el.value })) });
                    setIsTableRequest(!isTableRequest);
                  }}
                />
              ) : null}

              {(pageValue === 'feedbacks') && <CheckboxToggleBlue
                text='C текстом'
                value={isCheckWithText}
                onChange={(e) => setIsCheckWithText(!isCheckWithText)}
              />}
            </FilterContainer>

            {/* Табы */}
            <ViewSwitch
              disabled={isNotOneAccount !== 'done'}
              selectView={view}
              tile={false}
              tileLong={false}
              chat
              setSelectView={(e) => setView(e)}
            />
          </div>

          <div className="toolbar-medium">
            <div className="tabs-and-rating">
              <Tabs
                query={location.search}
                tabs={btn_tab}
                pageValue={pageValue}
                disabled={isNotOneAccount !== 'done'}
              />
            </div>
            <RangeBox
              date={date}
              disabled={isNotOneAccount !== 'done'}
              setDate={setDate}
              allPeriod={allPeriod}
              setAllPeriod={setAllPeriod}
            />
          </div>

          {isNotOneAccount === 'waiting' ? (
            <NoDataContent
              img={banner_no_data}
              title={'Подключение создано'}
              description={`Сбор и обработка информации займет до 24 часов.`}
            />
          ) : isNotOneAccount === 'none' ?
            <NoDataContent
              img={banner_no_data}
              title="Нет активных подключений"
              description="Создайте подключение чтобы пользоваться всеми инструментами сервиса"
              child={
                <ButtonBasic
                  green
                  onClick={(e) => {
                    openConnectionModalById([1, 3]);
                  }}
                  text="Новое подключение"
                  size="56px"
                />
              }
            />
            :
            <>
              {view == 'Chat' && (
                <ChatReview
                  btns={btns}
                  pageValue={pageValue}
                  counterData={counterData}
                  isSearchLastPage={isSearchLastPage}
                  setStatus={(e) => setSelectedStatus(e)}
                  status={selectedStatus}
                  path={path['*']}
                  setPage={(e) => setChatPage(e)}
                  resetHeight={resetHeight}
                  setResetHeight={(e) => setResetHeight(e)}
                  selectedMarketplace={selectedMarketplace}
                  _date={date}
                  allPeriod={allPeriod}
                  isCheckWithText={isCheckWithText}
                  selectedApi={selectedApi}
                  selectedBrand={selectedBrand}
                  selectedCategory={selectedCategory}
                  selectedRating={selectedRating}
                  selectedStatus={selectedStatus}
                />
              )}
            </>
          }

          {isNotOneAccount !== 'none' && view == 'Table' && (
            <TableBox
              {...tableProps}
              ref={paginatorRef}
              paginator={true}
              onCheck={(e) => onCheck(e)}
              loading={loading}
              onUncheckAllDependence={[
                pageValue,
                selectedStatus,
                selectedApi,
                selectedBrand,
                selectedCategory,
                selectedMarketplace,
                selectedRating,
                date,
              ]}
              onAction={(e) => onActionHandle(e)}
              fetchCallback={fetchTableData}
              child={
                <>
                  <TabsGreyBtn
                    btns={btns}
                    currentBtn={selectedStatus}
                    setCurrentBtn={setSelectedStatus}
                    checkValue
                  />

                  {pageValue == 'feedbacks' &&
                    <div className='work-with-reviews__btn-upload'>
                      <ButtonBasic
                        green
                        text='Загрузить из excel'
                        size='32px'
                        loading={loadingUpload}
                      />

                      <input
                        ref={fileInputRef}
                        type="file"
                        id="fileInput"
                        onChange={handleFileChange}
                      />
                    </div>
                  }

                  {
                    selectedStatus === 'Модерация' &&
                    <ButtonBasic
                      disabled={checkItems.length == 0}
                      onClick={(e) => {
                        fetchChangeStatus(true);
                        setCheckItems([]);
                      }}
                      green
                      text={'Подтвердить выбранные'}
                      size='32px'
                    />
                  }

                  {
                    selectedStatus === 'Модерация' &&
                    <ButtonBasic
                      onClick={(e) => {
                        fetchChangeStatusByFilters(true);
                      }}
                      green
                      text={'Подтвердить все'}
                      size='32px'
                    />
                  }

                  {
                    selectedStatus === 'Ответ ожидает отправления' &&
                    <ButtonBasic
                      disabled={checkItems.length == 0}
                      onClick={(e) => {
                        fetchChangeStatus(false);
                        setCheckItems([]);
                      }}
                      green
                      text={'Вернуть выбранные'}
                      size='32px'
                    />
                  }

                  {
                    selectedStatus === 'Ответ ожидает отправления' &&
                    <ButtonBasic
                      onClick={(e) => {
                        fetchChangeStatusByFilters(false);
                      }}
                      green
                      text={'Вернуть все'}
                      size='32px'
                    />
                  }
                </>
              }
            />
          )}
        </div>
      </div>
    </>
  );
};

export { WorkWithReviews };